import React from "react";
import ReactDOM from "react-dom";
import UserConfirmation from "../components/shared/common/UserConfirmation";

const getUserConfirmation = (message: string, callback: any) => {
  const modal = document.createElement("div");
  document.body.appendChild(modal);

  const withCleanup = (answer: boolean) => {
    ReactDOM.unmountComponentAtNode(modal);
    document.body.removeChild(modal);
    callback(answer);
  };

  ReactDOM.render(
    <UserConfirmation
      message={message}
      onCancel={() => withCleanup(false)}
      onConfirm={() => withCleanup(true)}
    />,
    modal
  );
};

export default getUserConfirmation;
